import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { Event } from '@ifeng-fe/ui_base';
import { handleAd } from '@ifeng-fe/ui_pc_ad';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Info from './info';

let adFlag = true;

class Recommend extends React.PureComponent {
    static propTypes = {
        data: PropTypes.array,
        count: PropTypes.array,
        infoAd: PropTypes.object,
    };

    state = {
        data: this.props.data,
    };

    event = new Event();

    static getDerivedStateFromProps(nextProps, prevState) {
        prevState.data.forEach(item => {
            if (item.type === 'ad') {
                adFlag = false;
            }
        });

        if (prevState.data !== nextProps.data && adFlag) {
            return {
                data: nextProps.data,
            };
        }

        return null;
    }

    async componentDidMount() {
        const { infoAd } = this.props;

        if (infoAd) {
            try {
                const callback = await handleAd(infoAd);

                callback(infoAd.data, this.event, this.insert);
            } catch (e) {
                console.error(e);
            }

            try {
                this.event.trigger('init');
            } catch (e) {
                console.error(e);
            }
        }
    }

    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    try {
                        adFn(dom);
                    } catch (e) {
                        console.error(e);

                        this.setState({
                            data,
                        });
                    }
                },
            );
        }

        return;
    };

    render() {
        const { data } = this.state;
        const { count } = this.props;
        const indexArr = [];

        data.forEach((item, index) => {
            if (item.type === 'ad') {
                indexArr.push(index);
            }
        });

        indexArr.forEach((item, index) => {
            count.splice(index, 0, {});
        });

        /* eslint-disable no-confusing-arrow */
        return (
            <div className={styles.recommend}>
                <div className={styles.list_box}>
                    {data.map(
                        (item, index) =>
                            item.type === 'ad' ? (
                                <div key={index} ref={item.ref} />
                            ) : (
                                <Info key={index} data={item} count={count[index] ? count[index] : {}} />
                            ),
                    )}
                </div>
            </div>
        );
        /* eslint-enable no-confusing-arrow */
    }
}

export default errorBoundary(Recommend);
